import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faCloud, faLock, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import logo from '../imgs/temporary-logo-3.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { login, user, loading, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      if (isAdmin()) {
        navigate('/admin', { replace: true });
      } else {
        navigate('/gallery', { replace: true });
      }
    }
  }, [user, loading, navigate, isAdmin]);

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const result = await login(email, password);
      if (result.success) {
        if (isAdmin()) {
          navigate('/admin', { replace: true });
        } else {
          navigate('/gallery', { replace: true });
        }
      } else {
        setPassword('');
        toast.error(result.message || 'Usuário ou senha incorretos', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (err) {
      console.error('Erro no handleSubmit:', err);
      setPassword('');
      toast.error('Erro inesperado. Tente novamente.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const features = [
    { icon: <FontAwesomeIcon icon={faBookOpen} />, label: 'Revistas' },
    { icon: <FontAwesomeIcon icon={faCloud} />, label: 'Nuvem' },
    { icon: <FontAwesomeIcon icon={faLock} />, label: 'Seguro' },
    { icon: <FontAwesomeIcon icon={faMobileAlt} />, label: 'Mobile' },
  ];

  const s = {
    page: {
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
    },
    left: {
      background: '#000',
      color: '#fff',
      flex: '0 0 50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      overflow: 'hidden',
      padding: '2.5rem 2rem',
    },
    right: {
      flex: '0 0 50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#F8FAFC',
      padding: '2rem',
    },
    leftLogo: {
      zIndex: 1,
      width: '140px',
      filter: 'brightness(0) invert(1)',
    },
    leftCenter: {
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    title: {
      fontSize: '2.2rem',
      fontWeight: '800',
      letterSpacing: '1px',
      background: 'linear-gradient(135deg, #ffffff 30%, #00B2A9 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      marginBottom: '2.2rem',
      lineHeight: 1.3,
    },
    iconsRow: {
      display: 'flex',
      gap: '1.8rem',
      justifyContent: 'center',
    },
    iconItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.5rem',
    },
    iconBox: {
      width: '52px',
      height: '52px',
      borderRadius: '14px',
      background: 'rgba(0,178,169,0.12)',
      border: '1px solid rgba(0,178,169,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.2s',
      cursor: 'default',
    },
    iconLabel: {
      fontSize: '0.72rem',
      color: '#888',
      letterSpacing: '0.5px',
    },
    leftFooter: {
      zIndex: 1,
      fontSize: '0.72rem',
      color: '#444',
      letterSpacing: '1px',
    },
    ledLine: (left, delay, opacity) => ({
      position: 'absolute',
      width: '2px',
      height: '100%',
      background: 'linear-gradient(to bottom, transparent, #00B2A9, transparent)',
      boxShadow: '0 0 8px #00B2A9',
      animation: `ledV 3s linear ${delay} infinite`,
      left,
      opacity: opacity * 2.5, // Brighter
    }),
    ledH: (top, delay, opacity) => ({
      position: 'absolute',
      height: '2px',
      width: '100%',
      background: 'linear-gradient(to right, transparent, #00B2A9, transparent)',
      boxShadow: '0 0 8px #00B2A9',
      animation: `ledH 6s linear ${delay} infinite`,
      top,
      opacity: opacity * 2.5, // Brighter
    }),
    formWrap: {
      width: '100%',
      maxWidth: '380px',
    },
    formTitle: {
      color: '#002F6C',
      fontWeight: '700',
      marginBottom: '0.3rem',
      fontSize: '22px',
      textAlign: 'center',
    },
    formSub: {
      color: '#64748b',
      marginBottom: '2rem',
      textAlign: 'center',
      fontSize: '14px',
    },
    label: {
      color: '#002F6C',
      fontWeight: '600',
      fontSize: '14px',
    },
    input: {
      borderRadius: '10px',
      padding: '12px 16px',
      border: '2px solid #e2e8f0',
      fontSize: '15px',
      color: '#334155',
      transition: 'all 0.2s ease',
      backgroundColor: '#fff',
    },
    btn: {
      background: '#000',
      border: 'none',
      borderRadius: '10px',
      padding: '13px',
      fontSize: '15px',
      fontWeight: '700',
      boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
      transition: 'all 0.2s ease',
      marginTop: '0.75rem',
      color: '#fff',
    },
  };

  return (
    <div style={s.page}>
      <style>{`
        @keyframes ledV {
          0%   { transform: translateY(-100%); }
          100% { transform: translateY(100%); }
        }
        @keyframes ledH {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .login-input:focus {
          border-color: #00B2A9 !important;
          background-color: #fff !important;
          box-shadow: 0 0 0 3px rgba(0,178,169,0.12) !important;
        }
        .login-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0,178,169,0.5) !important;
          background: #111 !important;
        }
        .login-btn:disabled { opacity: 0.6; }
        .feat-icon:hover {
          background: rgba(0,178,169,0.25) !important;
          border-color: rgba(0,178,169,0.7) !important;
        }
      `}</style>

      {/* ══════ LEFT SIDE ══════ */}
      <div style={s.left}>
        {/* LED vertical lines */}
        <div style={s.ledLine('8%',   '0s',   0.35)}></div>
        <div style={s.ledLine('30%',  '1.2s', 0.20)}></div>
        <div style={s.ledLine('55%',  '2.4s', 0.15)}></div>
        <div style={s.ledLine('80%',  '0.8s', 0.18)}></div>
        {/* LED horizontal line */}
        <div style={s.ledH('62%', '2s', 0.2)}></div>

        {/* Logo at top */}
        <div style={{ zIndex: 1 }}>
          <img src={logo} alt="Logo" style={s.leftLogo} />
        </div>

        {/* Center: title + icons */}
        <div style={s.leftCenter}>
          <h1 style={s.title}>Conecta revistas digitais</h1>
          <div style={s.iconsRow}>
            {features.map((f) => (
              <div key={f.label} style={s.iconItem}>
                <div className="feat-icon" style={s.iconBox}>
                  <span style={{ fontSize: '1.4rem' }}>{f.icon}</span>
                </div>
                <span style={s.iconLabel}>{f.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div style={s.leftFooter}>
          © {new Date().getFullYear()} · Revistas Digitais
        </div>
      </div>

      {/* ══════ RIGHT SIDE ══════ */}
      <div style={s.right}>
        <div style={s.formWrap}>
          <h2 style={s.formTitle}>Gestão de Revistas Digitais</h2>
          <p style={s.formSub}>Acesse sua conta para continuar</p>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={s.label}>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={handleEmailChange}
                required
                placeholder="seu@email.com"
                autoComplete="username"
                className="login-input"
                style={s.input}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={s.label}>Senha</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={handlePasswordChange}
                required
                placeholder="Sua senha"
                autoComplete="current-password"
                className="login-input"
                style={s.input}
              />
            </Form.Group>

            <Button
              type="submit"
              className="w-100 login-btn"
              disabled={isSubmitting}
              style={s.btn}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Entrando...
                </>
              ) : 'Entrar'}
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;